export enum GtmPageType {
    Cart = "cart",
    ConversionConfirmation = "conversionConfirmation"
}
